import Cookies from 'js-cookie'
import { SEGMENT_COOKIE_KEY } from '@/lib/data/constants'

export const getHypertuneCookieClient = () => {
  const hypertuneCookie = Cookies.get(SEGMENT_COOKIE_KEY)

  return hypertuneCookie as string
}
